<template>
  <div class="new-remind">
    <el-dialog
      title="天气提醒"
      :visible.sync="params.flag"
      v-dialogDrag
      :modal="false"
      width="30%"
      custom-class="warn"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :modal-append-to-body="false"
      ref="newRemRef"
      :before-close="
        () => params.flag && $parent.toggleProductView('NewRemind')
      "
    >
      <!--      <div class="search"><i></i><input v-model="search" placeholder="请输入项目名称"/></div>-->
      <div class="list">
        <div class="list-wrap">
          <el-table
            :data="
              tableData.filter(
                (data) =>
                  !search ||
                  data.objname.toLowerCase().includes(search.toLowerCase()),
              )
            "
            height="100%"
            style="width: 100%"
            header-row-class-name="r1"
          >
            <el-table-column prop="cont" label="消息内容"> </el-table-column>

            <el-table-column prop="crttimeFmt" label="发布时间" width="140px">
              <template slot-scope="scope">
                {{ scope.row.crttimeFmt.slice(0, -3) }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="objname" label="项目名称" width="100px"> </el-table-column> -->
            <!--            <el-table-column label="操作" width="80px">-->
            <!--              <template slot-scope="scope">-->
            <!--                <div @click="showMoreDetail(scope.row)" class="el-icon-more" title="更多"></div>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
          </el-table>
        </div>
      </div>
    </el-dialog>

    <more-detail
      ref="tqRed"
      title="天气提醒详情"
      width="40%"
      :detailDialogVisible="detailDialogVisible"
      :morDetailConfig="morDetailConfig"
      :detailData="detailData"
      @changeDialogVisible="detailDialogVisible = false"
    >
    </more-detail>
  </div>
</template>
<script>
import MoreDetail from "./module/MoreDetail.vue";
import { mapState } from "vuex";
export default {
  props: ["params"],
  data() {
    return {
      dialogTableVisible: false,
      tableData: [],
      search: "",
      rootFontSize: window.rootFontSize,
      detailData: {},
      detailDialogVisible: false,
      morDetailConfig: [
        { label: "标题", field: "title" },
        { label: "项目名称", field: "objname" },
        { label: "提醒内容", field: "cont" },
        // { label: '发布人', field: 'username' },
        // { label: '发布时间', field: 'crttimeFmt' }
      ],
    };
  },
  watch: {
    "params.flag": {
      handler(flag) {
        flag && this.setZindex();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("home", ["newestTxMsg"]),
  },
  mounted() {
    this.tableData = this.newestTxMsg;
  },
  methods: {
    showMoreDetail(data) {
      this.detailData = data;
      this.detailDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.tqRed.setZindex();
      });
    },
    // 设置弹出框的zIndex
    setZindex() {
      this.$nextTick(() => {
        const el = this.$refs.newRemRef;
        let zIndex = JSON.parse(localStorage.getItem("dialogZIndex"));
        zIndex = zIndex * 1 + 1;
        el.$el.style.zIndex = zIndex;
        localStorage.setItem("dialogZIndex", JSON.stringify(zIndex));
      });
    },
  },
  components: {
    MoreDetail,
  },
};
</script>
<style lang="less" scoped>
.new-remind {
  pointer-events: none;
  .search {
    width: 30rem;
    height: 2.5rem;
    border-radius: 0.38rem;
    border: 1px solid #52607f;
    display: flex;
    align-items: center;
    margin-bottom: 1.5%;
    background: #0c4170;
    i {
      display: inline-block;
      width: 1.13rem;
      height: 1.06rem;
      background: url("../assets/images/搜索.png") no-repeat;
      background-size: contain;
      margin: 0 0.44rem 0 1rem;
    }
    input {
      height: calc(2.5rem - 2px);
      flex: 1;
      border: 0;
      border-radius: 0.38rem;
      outline: none;
      font-size: 0.88rem;
      color: #fff;
      background: #0c4170;
    }
    input::placeholder {
      color: #fff;
    }
  }
  .list {
    flex: 1;
    position: relative;
    .list-wrap {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      .el-table {
        background: transparent;
        text-align: center;
        /deep/ .el-table__cell {
          padding: 2px 0;
        }
        /deep/ .r1 .el-table__cell:first-child {
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
        }
        /deep/ .r1 .el-table__cell:nth-child(3) {
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
        }
        /deep/ .r1 .el-table .el-table__cell.gutter {
          display: none !important;
        }
        /deep/ tr {
          background: transparent;
          th {
            text-align: center;
            border: 0;
            font-size: 0.88rem;
            font-weight: 600;
            color: #fff;
            background: #0c4170;
          }
          td {
            text-align: center;
            font-size: 0.88rem;
            font-weight: 400;
            color: #fff;
            border-bottom: 1px solid #ffffff;
          }
          .print {
            width: 1.13rem;
            height: 1.13rem;
            background: url("../assets/images/打印.png") no-repeat;
            border: 0;
            cursor: pointer;
            background-size: 1.13rem 1.13rem;
          }
          .image {
            margin: 0.52vw;
            width: 1.09vw;
            cursor: pointer;
          }
        }
        /deep/ tr:hover td {
          background: transparent !important;
        }

        .new {
          margin-left: 0.52vw;
          background-color: #f56c6c;
          border-radius: 0.32vw;
          color: #fff;
          display: inline-block;
          font-size: 0.43vw;
          height: 0.94vw;
          line-height: 0.94vw;
          padding: 0.1vw 0.31vw;
          text-align: center;
          white-space: nowrap;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background: #273458;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
          border-radius: 5px;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: #1b2230;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
          border-radius: 5px;
          background: #0c4170;
        }
        /deep/.el-table__fixed-right-patch {
          background: #1f2c49;
          border: 0;
        }
      }
      .el-table::before {
        background: transparent;
      }
    }
  }
  /deep/.el-dialog__wrapper {
    overflow: hidden;
    .el-dialog {
      pointer-events: auto;
    }
  }
}
</style>
